import PropTypes from 'prop-types';

const { arrayOf, number, string, shape } = PropTypes;

export const headerShape = shape({
  content: string,
  headerWidth: number,
  headerAlignment: string,
});

export const rowShape = shape({
  internalTitle: string,
  content: string,
});

export const columnShape = shape({
  columnHeaderInternal: string,
  rows: arrayOf(rowShape),
});

export default shape({
  tableHeaders: arrayOf(headerShape),
  tableColumns: arrayOf(columnShape),
  mobileTableStyle: string,
});
